import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=9f5cafee&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5cafee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5cafee')) {
      api.createRecord('9f5cafee', component.options)
    } else {
      api.reload('9f5cafee', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=9f5cafee&scoped=true", function () {
      api.rerender('9f5cafee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkSignaturePad/Image.vue"
export default component.exports